import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="admin--users--search"
export default class extends Controller {
  static targets = ["form"];

  onCompanyChange(event) {
    const selectedCompanyId = event.target.value;
    const baseUrl = this.formTarget.dataset.baseUrl;
    const url = baseUrl.replace('company_id', selectedCompanyId);
    this.formTarget.action = url;
  }
}
